import { browserName, osName, osVersion } from 'react-device-detect';

import {
	LoggerMessages,
	LoggerServices,
	LogLevel,
	SERVICE_NAME,
	type TLoggerMessages,
} from '../shared';
import type { Log } from '../shared/types';
import { Datadog } from './datadog';

class ClientLogger {
	private userId: string | undefined;
	private isTestUser = false;

	updateUserId = (userId: string | undefined, isTestUser: boolean) => {
		this.userId = userId;
		this.isTestUser = isTestUser;
	};

	logForTestUser = (message: string) => {
		if (this.isTestUser) {
			this.log(
				LogLevel.info,
				LoggerServices.TestUserService,
				LoggerMessages.TestUserMessage,
				{ message }
			);
			// eslint-disable-next-line no-console
			console.log(`[Logger][Test user log]: ${message}`);
		}
	};

	log = (
		level: LogLevel,
		service: LoggerServices,
		message: TLoggerMessages,
		payload: Record<string, unknown>
	) => {
		const navInfo = navigator as NavigatorNetworkInformation;
		const connection: { effectiveType?: string } | undefined =
			navInfo.connection || navInfo.mozConnection || navInfo.webkitConnection;

		const log = {
			service,
			message,
			payload,
			product: SERVICE_NAME,
			userId: this.userId,
			connectionEffectiveType: connection?.effectiveType,
			browser: browserName,
			os: osName,
			osVersion,
		} as Log;

		Datadog.log(level, log);
	};
}

const shared = new ClientLogger();
export default shared;
